class PowerDriveEquipmentFinder extends HTMLElement {
  connectedCallback() {
    if (this.dataset.pdFinderReady === "true") return;

    this.dataset.pdFinderReady = "true";

    this.querySelectorAll("[data-pd-destination-form]").forEach((form) => {
      form.addEventListener("submit", (event) => {
        event.preventDefault();

        const destination = form.querySelector("[data-pd-destination]");
        if (!destination || !destination.value) {
          destination?.focus();
          return;
        }

        window.location.assign(destination.value);
      });
    });

    this.querySelectorAll("[data-pd-stock-form]").forEach((form) => {
      form.addEventListener("submit", async (event) => {
        event.preventDefault();

        const input = form.querySelector('input[name="q"]');
        const button = form.querySelector("[data-pd-stock-button]");
        const status = this.querySelector("[data-pd-stock-status]");
        const stockNumber = input?.value.trim() || "";

        if (!stockNumber) {
          input?.focus();
          return;
        }

        if (button) button.disabled = true;
        form.setAttribute("aria-busy", "true");

        if (status) {
          status.hidden = false;
          status.textContent = "Checking current Power Drive inventory...";
        }

        try {
          const lookupUrl = new URL(
            "/apps/voigt/equipment-lookup",
            window.location.origin,
          );
          lookupUrl.searchParams.set("stock", stockNumber);

          const response = await fetch(lookupUrl, {
            headers: {
              Accept: "application/json",
            },
          });
          const result = await response.json();

          if (response.ok && result.found && result.product_url) {
            window.location.assign(result.product_url);
            return;
          }

          if (status) {
            status.textContent =
              "No active listing matched that stock number. Please check the number or call our equipment team.";
          }
        } catch (_error) {
          if (status) {
            status.textContent =
              "Stock lookup is temporarily unavailable. Please call our equipment team for assistance.";
          }
        } finally {
          if (button) button.disabled = false;
          form.removeAttribute("aria-busy");
        }
      });
    });
  }
}

if (!customElements.get("pd-equipment-finder")) {
  customElements.define("pd-equipment-finder", PowerDriveEquipmentFinder);
}
